import { IUpdateChecklistMaquinaEquipUseCase } from "../../../../controledePatrimonio/presentation/useCases/update/update_checklist_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
/**
 * UpdateChecklistMaquinaEquipUseCase
 */
export class UpdateChecklistMaquinaEquipUseCase implements IUpdateChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idChecklistMaquinaEquip: number,
    status: boolean,
    codigo?: string,
    revisao?: string,
    descricao?: string,
  ): Promise<void> {
    await this.repository.updateChecklistMaquinaEquip(
      idChecklistMaquinaEquip,
      status,
      codigo,
      revisao,
      descricao
    );
  }
}
